import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    MenuItem,
    Stack,
    TextField,
    Typography,
    Avatar,
    FormControlLabel,
    Checkbox,
  } from "@mui/material";
  import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IAccountCreateRequest } from "../../store/interfaces/IAccount";
import { useCreateAccountImageMutation, useCreateAccountMutation } from "../../store/api";
import { enqueueSnackbar, SnackbarKey, useSnackbar } from "notistack";
import { HighlightOff } from "@mui/icons-material";
  


  const initialState: IAccountCreateRequest = {
    name: "",
    email: "",
    logo: "",
    owner: false,
    url: "",
    primaryColor: "#000000",
    secondaryColor: "#2e2ed2",
    socialMediaList: [
      { name: "instagram", username: "" },
      { name: "supportWhatsapp", username: "" },
    ],
    sendEmailConf: {
      gmail: "",
      gpass: "",
    },
    sorter: {
      name: "",
      lastname: "",
      email: "",
      status: "ACTIVE",
      password: "",
      profile: "admin",
      accountId: "",
    },
  };
  
  interface AccountFormProps {
    setOpenDialog: Dispatch<SetStateAction<boolean>>;
  }

  export const AccountForm = ({setOpenDialog}: AccountFormProps) => {


    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const handleSnackbarClose = (key: SnackbarKey) => {
        closeSnackbar(key);
    };


        function showToast(message: string, variant: string) {
    if (variant !== "success" && variant !== "warning" && variant !== "error") {
      return;
    }
    enqueueSnackbar(message, {
      action: (key) => {
        return (
          <HighlightOff
            sx={{ cursor: "pointer" }}
            onClick={() => handleSnackbarClose(key)}
          />
        );
      },
      variant: variant,
      anchorOrigin: {
        horizontal: "right",
        vertical: "top",
      },
    });
  }



    const [formData, setFormData] = useState(initialState);
    const [logoPreview, setLogoPreview] = useState<string | null>(null);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [createAccount, {data: createAccountResponse, error: errorCreatingAccount}] = useCreateAccountMutation();
    const [createAccountImage, {data: createAccountImageResponse}] = useCreateAccountImageMutation();


    
    useEffect(() => {
        if (createAccountResponse && logoFile) {
            createAccountImage({
                accountId: formData.sorter.accountId,
                imageFile: logoFile,
                imageName: `${formData.sorter.accountId}.png`,
            }).then((response) => {
                showToast('Imagen creada', 'success'); 
              }).catch((error) => {
                showToast('Hubo un error al crear la imagen', 'error'); 
              });
        }
    }, [createAccountResponse])

    useEffect(() => {
      if (createAccountImageResponse) {
        console.log(`
            URL Inicio de venta: ${formData.url}
            
            URL Inicio de sesion: ${formData.url}/login
            
            Credenciales inicio de sesion: 
            Usuario: ${formData.sorter.email}
            Contraseña: ${formData.sorter.password}
          `)
          setOpenDialog(false)
          window.open(formData.url, '_blank');
      }

    }, [createAccountImageResponse])
  
    const handleChange = (field: string, value: any) => {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    };
  
    const handleSorterChange = (field: string, value: any) => {
      setFormData((prev) => ({
        ...prev,
        sorter: {
          ...prev.sorter,
          [field]: value,
        },
      }));
    };
  
    const handleSocialChange = (index: number, value: string) => {
      const newSocialList = [...formData.socialMediaList];
      newSocialList[index].username = value;
      setFormData((prev) => ({
        ...prev,
        socialMediaList: newSocialList,
      }));
    };
  
    const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        setLogoFile(file)
        setLogoPreview(URL.createObjectURL(file));
      }
    };
  
    const handleSubmit = () => {
        createAccount({...formData, logo: `${formData.sorter.accountId}.png`})
    };
  
    return (
      <Card sx={{ maxWidth: 900, mx: "auto", mt: 2, borderRadius: 3, boxShadow: 6 }}>
        <CardContent>  
          <Box component="form" noValidate autoComplete="off">
            <Grid container spacing={3}>
              {/* Account Info */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Account Name"
                  fullWidth
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  fullWidth
                  value={formData.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
              </Grid>
  
              {/* Logo Upload */}
              <Grid item xs={12} sm={6}>
                <Button variant="outlined" component="label" fullWidth>
                  Upload Logo
                  <input type="file" hidden accept="image/*" onChange={handleLogoUpload} />
                </Button>
                {formData.logo && (
                  <Typography mt={1} variant="body2">
                    Selected: <strong>{formData.logo}</strong>
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                {logoPreview && (
                  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <Avatar
                      src={logoPreview}
                      alt="Logo Preview"
                      sx={{ width: 56, height: 56, mx: "auto" }}
                    />
                  </Box>
                )}
              </Grid>
  
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Website URL"
                  fullWidth
                  value={formData.url}
                  onChange={(e) => handleChange("url", e.target.value)}
                />
              </Grid>
  
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Primary Color"
                  type="color"
                  fullWidth
                  value={formData.primaryColor}
                  onChange={(e) => handleChange("primaryColor", e.target.value)}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  label="Secondary Color"
                  type="color"
                  fullWidth
                  value={formData.secondaryColor}
                  onChange={(e) => handleChange("secondaryColor", e.target.value)}
                />
              </Grid>
  
              {/* Social Media */}
              <Grid item xs={12}>
                <Typography fontWeight="bold" gutterBottom>
                  Social Media
                </Typography>
                <Stack spacing={2}>
                  {formData.socialMediaList.map((social, index) => (
                    <TextField
                      key={social.name}
                      label={social.name}
                      fullWidth
                      value={social.username}
                      onChange={(e) => handleSocialChange(index, e.target.value)}
                    />
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={formData.owner}
                        onChange={(e) => handleChange("owner", e.target.checked)}
                    />
                    }
                    label="Owner"
                />
                </Grid>
                <Grid item xs={12}>
                  <Typography fontWeight="bold" gutterBottom mt={2}>
                    Send Email Config
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Gmail"
                    fullWidth
                    value={formData.sendEmailConf.gmail}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        sendEmailConf: {
                          ...prev.sendEmailConf,
                          gmail: e.target.value,
                        },
                      }))
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Gmail Password"
                    type="password"
                    fullWidth
                    value={formData.sendEmailConf.gpass}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        sendEmailConf: {
                          ...prev.sendEmailConf,
                          gpass: e.target.value,
                        },
                      }))
                    }
                  />
                </Grid>

              {/* Sorter Info */}
              <Grid item xs={12}>
                <Typography fontWeight="bold" gutterBottom mt={2}>
                  Sorter Info
                </Typography>
              </Grid>
  
              <Grid item xs={12} sm={6}>
                <TextField
                  label="First Name"
                  fullWidth
                  value={formData.sorter.name}
                  onChange={(e) => handleSorterChange("name", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Last Name"
                  fullWidth
                  value={formData.sorter.lastname}
                  onChange={(e) => handleSorterChange("lastname", e.target.value)}
                />
              </Grid>
  
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  fullWidth
                  value={formData.sorter.email}
                  onChange={(e) => handleSorterChange("email", e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Password"
                  type="password"
                  fullWidth
                  value={formData.sorter.password}
                  onChange={(e) => handleSorterChange("password", e.target.value)}
                />
              </Grid>
  
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Profile"
                  fullWidth
                  select
                  value={formData.sorter.profile}
                  onChange={(e) => handleSorterChange("profile", e.target.value)}
                >
                  <MenuItem value="admin">Admin</MenuItem>
                  <MenuItem value="user">User</MenuItem>
                </TextField>
              </Grid>
  
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Account ID"
                  fullWidth
                  value={formData.sorter.accountId}
                  onChange={(e) => handleSorterChange("accountId", e.target.value)}
                />
              </Grid>
            </Grid>
  
            <Box mt={4}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                fullWidth
                size="large"
                sx={{ fontWeight: "bold" }}
              >
                Create Account
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };
  